export default __webpack_public_path__ + "static/springandsummer (1)-dcfc5f3a86a607dbc3f58a1b3963261e.jpeg";